import background from './background.png';
import styles from './index.module.less';

function DefaultSiteThumbnail() {
  return (
    <div className={styles.thumbnail}>
      <div className={styles.header}>
        <span className={styles['control-red']} />
        <span className={styles['control-yellow']} />
        <span className={styles['control-green']} />
      </div>
      <div className={styles.content}>
        <img className={styles.image} src={background} alt="" />
      </div>
    </div>
  );
}

export default DefaultSiteThumbnail;
